import React from "react";
//#region types
import { FromRecurringInvoiceBannerProps } from "models/propTypes/invoicePropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Banner, StyledButton, useCheckRelations } from "components/common";
import { Grid } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { useRecurringInvoiceService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance, UrlHelper } from "utils/helpers";

const FromRecurringInvoiceBanner: React.FC<FromRecurringInvoiceBannerProps> = (props) => {
  const recurringInvoiceService = useRecurringInvoiceService();
  const { invoice, displayType } = props;
  const location = useLocation();
  const navigate = useNavigate();

  const onOpenRecurringClicked = () => {
    navigate(UrlHelper.formatPath(`/RecurringInvoice/${invoice.recurringId}`), {
      state: { background: location },
    });
  };

  const { getIsReadonlyUser } = useCheckRelations();

  if (getIsReadonlyUser()) {
    return <></>;
  }
  return (
    <Banner
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.RecurringInvoice)}
      icon={IconDefinitionConstants.WBolt}
      type={displayType}
    >
      <Grid container direction="column" spacing={3}>
        <Grid item>
          {LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Invoice.RecurringInvoiceDescription,
            undefined,
            {
              frequency:
                invoice.recurringFrequency !== undefined
                  ? recurringInvoiceService.getFrequencyText(invoice.recurringFrequency).toLocaleLowerCase()
                  : "0",
            }
          )}
        </Grid>
        <Grid item>
          <StyledButton size="sm" displayType={displayType} onClick={onOpenRecurringClicked}>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.RecurringInvoice)}
          </StyledButton>
        </Grid>
      </Grid>
    </Banner>
  );
};

export default FromRecurringInvoiceBanner;
